<template>
  <div v-if="show">
    <div class="opc-cart__main__divider"></div>
    <div class="opc-cart__line">
      <div class="opc-cart__line__text">{{ $t(`billing.order_summary.prorated_charge_today`) }}</div>
      <div class="opc-cart__line__text">
        {{ this.$money(this.getProratedChargeAmount) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getProratedChargeAmount',
    ]),
    show() {
      return !!this.getProratedChargeAmount;
    },
  },
};
</script>

<style lang="scss">
@import "./prorated-charge";
</style>
